import { Entity, LiveData } from '@toeverything/infra';

export class QuotaCheckDialog extends Entity {
  readonly isOpen$ = new LiveData(false);

  open() {
    this.isOpen$.next(true);
  }

  close() {
    this.isOpen$.next(false);
  }
}
